import { render, staticRenderFns } from "./HistoricalAgreementDetails.vue?vue&type=template&id=59a3d3d8"
import script from "./HistoricalAgreementDetails.vue?vue&type=script&lang=js"
export * from "./HistoricalAgreementDetails.vue?vue&type=script&lang=js"
import style0 from "./HistoricalAgreementDetails.vue?vue&type=style&index=0&id=59a3d3d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports